module.exports = __webpack_public_path__ + "static/assets/b39c11251b02102b4a748769579793a4.png";